module.exports = __webpack_public_path__ + "fonts/Montserrat-Bold.942c288.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Montserrat/Montserrat-Bold.woff
// module id = 187
// module chunks = 245 246